<template>
  <b-card v-if="data" no-body class="card-bonus shadow-sm">
    <b-card-header class="text-center">
      <b-card-title>{{ $t("Comissões") }}</b-card-title>
    </b-card-header>
    <b-card-body>
      <div class="text-center mb-3">
        <b-button :variant="buttonVariant" @click="copyReferenceLink" class="btn-invite">
          {{ buttonText }}
        </b-button>
      </div>
      <!-- Detalhes dos bônus -->
      <b-list-group flush>
        <b-list-group-item v-for="media in data.mediaData" :key="media.avatar" class="d-flex align-items-center">
          <b-avatar :variant="media.color == 'success' ? 'light-primary' : 'light-info'" size="34" class="mr-3">
            <feather-icon :icon="media.avatar" size="18" />
          </b-avatar>
          <div>
            <h6 class="mb-0 font-weight-bold">{{ media.title }}</h6>
            <small class="text-muted">{{ $t(media.subtitle) }}</small>
          </div>
          <span class="ml-auto font-weight-bold">{{ media.amount }}</span>
        </b-list-group-item>
      </b-list-group>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardTitle,
  BListGroup,
  BListGroupItem,
  BButton,
  BAvatar,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
import copy from "copy-text-to-clipboard";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BListGroup,
    BListGroupItem,
    BButton,
    BAvatar,
  },
  props: {
    data: Object,
  },
  computed: {
    ...mapGetters(["returnUser"]),
  },
  data() {
    return {
      referenceLink: "",
      buttonText: this.$t("Copiar link de convite"),
      buttonVariant: "primary",
    };
  },
  mounted() {
    this.referenceLink = `${process.env.VUE_APP_FRONT_URL}/ref/${this.returnUser._id}`;
  },
  methods: {
    copyReferenceLink() {
      // Copia o link
      copy(this.referenceLink);

      // Altera o texto e a cor do botão temporariamente
      this.buttonText = this.$t("Link copiado!");
      this.buttonVariant = "success";

      // Retorna ao estado original após 3 segundos
      setTimeout(() => {
        this.buttonText = this.$t("Copiar link de convite");
        this.buttonVariant = "primary";
      }, 3000);
    },
  },
};
</script>

<style scoped>
.card-bonus {
  background-color: #FFFFFF;
  border-radius: 12px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid #e6e6e6;
}

.btn-invite {
  color: #FFFFFF;
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-weight: bold;
}

.b-list-group-item {
  background-color: transparent;
  padding: 0.75rem 1rem;
  border: none;

  &:not(:last-child) {
    border-bottom: 1px solid #FFFFFF;
  }
}

.text-muted {
  color: #6c757d !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}
</style>
